import { Card } from "@/components/ui/card";
import { FileText, Car, ScrollText } from "lucide-react";

const GROUPS = [
  {
    icon: FileText,
    title: "Borrower Documents",
    items: ["PAN card", "Aadhaar card", "Address proof", "Bank statement (6–12 months)", "Income proof (salary slips / business income)", "ITR / GST returns (if self-employed)", "Credit bureau (CIBIL) consent", "Account Aggregator consent", "Residence proof", "Business proof (if applicable)", "Trade license (if applicable)", "Udyam / GST certificate (if applicable)"],
  },
  {
    icon: Car,
    title: "Vehicle Documents",
    items: ["Registration Certificate (RC)", "Insurance policy", "Pollution certificate (PUC)", "CarDr diagnostic report", "Valuation report", "Dealer invoice", "Existing hypothecation NOC (if any)", "Challan check", "Vehicle photos", "Delivery confirmation"],
  },
  {
    icon: ScrollText,
    title: "Loan Documents",
    items: ["Sanction letter", "Loan agreement", "Key Fact Statement (KFS)", "Form 34 (hypothecation)", "Hypothecation forms", "eNACH mandate", "UPI mandate (if applicable)", "Disbursement confirmation", "Co-borrower documents (if applicable)", "Guarantor documents (if applicable)"],
  },
];

export default function DocumentsRequired() {
  return (
    <div className="max-w-6xl mx-auto px-4 lg:px-8 py-12" data-testid="documents-required-page">
      <div className="text-xs uppercase tracking-widest text-teal-700 font-semibold mb-2">Be prepared · Faster approval</div>
      <h1 className="text-4xl sm:text-5xl font-semibold text-slate-900 mb-3">Documents Required</h1>
      <p className="text-slate-600 max-w-2xl mb-10">
        Self-employed or cash-income borrower? Don't worry — we underwrite on bank cash flow,
        not just salary slips. Upload what you have; our team will guide you on the rest.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {GROUPS.map(g => {
          const Icon = g.icon;
          return (
            <Card key={g.title} className="p-6 border-slate-200" data-testid={`doc-group-${g.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <Icon className="text-teal-600 mb-3" size={22} />
              <div className="font-semibold text-slate-900 mb-3">{g.title}</div>
              <ul className="space-y-2 text-sm text-slate-600">
                {g.items.map(it => <li key={it} className="flex gap-2"><span className="text-teal-600">•</span>{it}</li>)}
              </ul>
            </Card>
          );
        })}
      </div>
      <div className="mt-10 p-5 rounded-lg bg-teal-50 border border-teal-200 text-sm text-teal-900">
        <strong>Trust note:</strong> CarFin India originates used car loans through Red Fort Capital Finance NBFC and may support bank/NBFC co-lending partners.
      </div>
    </div>
  );
}
